import styled from 'styled-components'
import { DANGER } from '../../styles/colors.style'

const Error = styled.p`
	font-size: 15px;
	color: ${DANGER};
	margin: 0;
	padding: 0;
`

export default Error
